module.exports = __webpack_public_path__ + "img/cross.c570fde7.svg";